// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as StoreId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Store/StoreId.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function toShowsideCategory(category) {
  var newrecord = Caml_obj.obj_dup(LegacyShowside_CategoryDecoders$ApiTypes.empty);
  newrecord.categoryType = {
    TAG: /* Standard */1,
    _0: {
      firstCard: undefined,
      externalConnection: {
        TAG: /* StoreCategory */0,
        _0: {
          categoryId: Curry._1(StoreId$ApiTypes.CategoryId.toString, category.id),
          sortBy: /* Default */0,
          filterBy: undefined,
          count: Belt_Option.getWithDefault(category.productsCount, 0),
          relatedMediaCount: undefined
        }
      },
      children: [],
      loadMoreChildren: undefined,
      totalChildren: 0,
      link: category.link,
      products: [],
      taggedMedia: undefined,
      imageHotspots: undefined,
      imageWidth: undefined,
      imageHeight: undefined
    }
  };
  newrecord.card = {
    TAG: /* MedialessLinkCard */5,
    _0: {
      link: {
        TAG: /* URL */0,
        _0: Belt_Option.getWithDefault(category.link, "")
      },
      size: /* Md */4,
      shape: /* Square */1
    }
  };
  newrecord.title = Belt_Option.getWithDefault(category.name, "");
  newrecord.id = Curry._1(StoreId$ApiTypes.CategoryId.toString, category.id);
  return newrecord;
}
export { toShowsideCategory };
/* StoreId-ApiTypes Not a pure module */